import React from "react";
import class1 from "../../assets/snacks.jpg";
import class2 from "../../assets/drinks.jpg";
import class3 from "../../assets/newari.jpg";
import styles from "./Cards.css";
const Classes = () => {
  return (
    <div class="container-xxl py-1" id="classes">
      <p data-aos="slide-right" data-aos-offset="220" className="heading">
        Our Special Cuisines{" "}
      </p>
      {/* <p data-aos="slide-left" className="sub_text">
        Elevate your dish experience!{" "}
      </p> */}
      <div class="container">
        <div
          class="text-center mx-auto mb-5 wow fadeInUp"
          data-wow-delay="0.1s"
          style={{ maxWidth: "600px" }}
        ></div>
        <div class="row g-4">
          <div
            data-aos="fade-right"
            data-aos-offset="170"
            class="col-lg-4 col-md-6 wow fadeInUp"
            data-wow-delay="0.1s"
          >
            <div class="classes-item">
              <div class="bg-light rounded-circle w-75 mx-auto p-3">
                <img class="img-fluid rounded-circle" src={class1} alt="" />
              </div>
              <div class="bg-light rounded p-4 pt-5 mt-n5">
                <p class="d-block text-center text-bold h3 mt-3 mb-4" href="">
                  Snacks
                </p>
                <div class="align-items-start justify-content-between mb-4">
                  <div class=" align-items-start">
                    <div class="ms-3">
                      <h6 class=" mb-4 d-flex" id="goldtext">
                        Crispy Chicken{" "}
                        <span className="element-price-list-separator"></span>{" "}
                        <span className="element-price-list-price"> $20</span>{" "}
                      </h6>
                      <p className="text-start">Pepper & barbecue sauce</p>
                      <h6 class=" mb-4 d-flex" id="goldtext">
                        Cheese And Sauces{" "}
                        <span className="element-price-list-separator"></span>{" "}
                        <span className="element-price-list-price"> $20</span>{" "}
                      </h6>
                      <p className="text-start">Pepper & barbecue sauce</p>{" "}
                      <h6 class=" mb-4 d-flex" id="goldtext">
                        Cheese And Sauces{" "}
                        <span className="element-price-list-separator"></span>{" "}
                        <span className="element-price-list-price"> $20</span>{" "}
                      </h6>
                      <p className="text-start">Pepper & barbecue sauce</p>
                    </div>
                  </div>
                  <span
                    id="gold"
                    class=" text-white rounded-pill py-2 px-3"
                    href=""
                  >
                    $99
                  </span>
                </div>
                <div class="row g-1">
                  <div class="col-4">
                    <div class="border-top border-3 border-primary pt-2"></div>
                  </div>
                  <div class="col-4">
                    <div class="border-top border-3 border-success pt-2"></div>
                  </div>
                  <div class="col-4">
                    <div class="border-top border-3 border-warning pt-2"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            data-aos="fade-up"
            class="col-lg-4 col-md-6 wow fadeInUp"
            data-wow-delay="0.3s"
          >
            <div class="classes-item">
              <div class="bg-light rounded-circle w-75 mx-auto p-3">
                <img class="img-fluid rounded-circle" src={class2} alt="" />
              </div>
              <div class="bg-light rounded p-4 pt-5 mt-n5">
                <h class="d-block text-center h3 mt-3 mb-4" href="">
                  Drinks
                </h>
                <div class="align-items-start justify-content-between mb-4">
                  <div class=" align-items-start">
                    <div class="ms-3">
                      <h6 class=" mb-4 d-flex" id="goldtext">
                        Crispy Chicken{" "}
                        <span className="element-price-list-separator"></span>{" "}
                        <span className="element-price-list-price"> $20</span>{" "}
                      </h6>
                      <p className="text-start">Pepper & barbecue sauce</p>
                      <h6 class=" mb-4 d-flex" id="goldtext">
                        Cheese And Sauces{" "}
                        <span className="element-price-list-separator"></span>{" "}
                        <span className="element-price-list-price"> $20</span>{" "}
                      </h6>
                      <p className="text-start">Pepper & barbecue sauce</p>{" "}
                      <h6 class=" mb-4 d-flex" id="goldtext">
                        Cheese And Sauces{" "}
                        <span className="element-price-list-separator"></span>{" "}
                        <span className="element-price-list-price"> $20</span>{" "}
                      </h6>
                      <p className="text-start">Pepper & barbecue sauce</p>
                    </div>
                  </div>
                  <span
                    id="gold"
                    class=" text-white rounded-pill py-2 px-3"
                    href=""
                  >
                    $99
                  </span>
                </div>
                <div class="row g-1">
                  <div class="col-4">
                    <div class="border-top border-3 border-primary pt-2"></div>
                  </div>
                  <div class="col-4">
                    <div class="border-top border-3 border-success pt-2"></div>
                  </div>
                  <div class="col-4">
                    <div class="border-top border-3 border-warning pt-2"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            data-aos="fade-right"
            class="col-lg-4 col-md-6 wow fadeInUp"
            data-wow-delay="0.5s"
          >
            <div class="classes-item">
              <div class="bg-light rounded-circle w-75 mx-auto p-3">
                <img class="img-fluid rounded-circle" src={class3} alt="" />
              </div>
              <div class="bg-light rounded p-4 pt-5 mt-n5">
                <h class="d-block text-center h3 mt-3 mb-4" href="">
                  Newari
                </h>
                <div class="align-items-start justify-content-between mb-4">
                  <div class=" align-items-start">
                    <div class="ms-3">
                      <h6 class=" mb-4 d-flex" id="goldtext">
                        Crispy Chicken{" "}
                        <span className="element-price-list-separator"></span>{" "}
                        <span className="element-price-list-price"> $20</span>{" "}
                      </h6>
                      <p className="text-start">Pepper & barbecue sauce</p>
                      <h6 class=" mb-4 d-flex" id="goldtext">
                        Cheese And Sauces{" "}
                        <span className="element-price-list-separator"></span>{" "}
                        <span className="element-price-list-price"> $20</span>{" "}
                      </h6>
                      <p className="text-start">Pepper & barbecue sauce</p>{" "}
                      <h6 class=" mb-4 d-flex" id="goldtext">
                        Cheese And Sauces{" "}
                        <span className="element-price-list-separator"></span>{" "}
                        <span className="element-price-list-price"> $20</span>{" "}
                      </h6>
                      <p className="text-start">Pepper & barbecue sauce</p>
                    </div>
                  </div>
                  <span
                    id="gold"
                    class=" text-white rounded-pill py-2 px-3"
                    href=""
                  >
                    $99
                  </span>
                </div>
                <div class="row g-1">
                  <div class="col-4">
                    <div class="border-top border-3 border-primary pt-2"></div>
                  </div>
                  <div class="col-4">
                    <div class="border-top border-3 border-success pt-2"></div>
                  </div>
                  <div class="col-4">
                    <div class="border-top border-3 border-warning pt-2"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Classes;
